





































import { Component, Vue } from 'vue-property-decorator'
import { logout, updatePassword } from '@/api/user'
import md5 from 'js-md5'
import { isValidPassword } from '@/utils/validate'
import { navKeyUrlMap, navUrlKeyMap } from '@/constant/navbarConstant'
import { USER } from '@/constant/storageConstant'

@Component({
  name: 'Nav'
})
export default class extends Vue {
  private isLogin = localStorage.getItem(USER) !== null
  private activeIndex = '1'

  private position = 'position:absolute;right:0;'

  private editPasswordVisible = false
  private editLoading = false
  private updatePassword = {
    oldPassword: '',
    newPassword: ''
  }

  mounted () {
    this.activeIndex = this.descPage(location.hash.substring(1))
    const userAgent = navigator.userAgent
    if (userAgent.indexOf('Android') >= 0 || userAgent.indexOf('iPhone') >= 0) {
      this.position = ''
    }
  }

  private descPage (page: string) {
    return navUrlKeyMap[page]
  }

  private async handleSelect (key: string) {
    if (key.startsWith('92')) {
      return
    }
    if (location.hash === '#/todoList' || key !== this.activeIndex) {
      const page = navKeyUrlMap[key]
      await this.$router.push({
        path: page
      })
    }
  }

  private async handleLogout () {
    const result = await logout()
    if (result.status) {
      this.isLogin = false
      localStorage.clear()
      if (location.hash !== '#/') {
        await this.$router.push({
          path: '/'
        })
      }
    }
  }

  private async submitUpdatePassword () {
    if (this.updatePassword.oldPassword === '' ||
      this.updatePassword.newPassword === '' ||
      this.updatePassword.oldPassword === this.updatePassword.newPassword) {
      this.$message.error('请完善信息')
      return
    }

    if (!isValidPassword(this.updatePassword.newPassword)) {
      this.$message.error('请填写正确的密码，必须包含6位以上，并且含大写字母，小写字母，数字，特殊符号中的三种及以上')
      return
    }

    this.editLoading = true
    const param = {
      oldPassword: md5(this.updatePassword.oldPassword),
      newPassword: md5(this.updatePassword.newPassword)
    }
    const result = await updatePassword(param)
    if (result.status) {
      this.$message.success('修改成功')
    }
    this.updatePassword = {
      oldPassword: '',
      newPassword: ''
    }
    this.editLoading = false
    this.editPasswordVisible = false
  }
}
